import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";

// Icons
//core components
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import CardIcon from "../../components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import Switch from "@material-ui/core/Switch";
import green from "@material-ui/core/colors/green";
import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
// import { axiosInstance as axios } from "../../utils/util";
import { domain } from "../../utils/util";
import { hist } from "../../index";
import { QRCodeSVG } from "qrcode.react";

class ManageCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      userToDeleteId: null,
      active: true,
      customerData: null,
      id: null,
      showreject: false,
      search_event: "",
      data: null,
      qrValue: null,
      showQRModal: false,
    };
  }

  componentWillMount = () => {
    // this.props.fetchUsers()
    // this.props.getCustomerData();
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    axios
      .get(`${domain}/user/customer/appuser/list`, config)
      .then((res) => {
        if (res) {
          this.setState({
            customerData: res.data && res.data.data,
            data: res.data && res.data.data,
          });
        } else if (res && res.data && res.data.statusCode === 401) {
          localStorage.removeItem("BerPay_Admin");
          this.props.history.push("/admin/pages/login-page");
        }
      })
      .catch((error) => {});
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      // {
      //   width: 150,
      //   Header: "KYC Status",
      //   accessor: "kyc_verified",
      // },
      {
        Header: " Profile",
        width: 90,
        Cell: (props) => {
          return (
            <img
              className={props.original.profile_pic ? "profile_pic" : null}
              src={props.original.profile_pic}
            />
          );
        },
      },
      {
        Header: "Wallet Balance",
        accessor: "walletBalance",
        width: 120,
        Cell: ({ value }) => {
          if (!value) return "0.00 USDC"; // default when empty/0
      
          const num = parseFloat(value);
          return `${num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDC`;
        },
      },
      {
        Header: "Username",
        accessor: "user_name",
        width: 130,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Prefix",
        accessor: "prefix",
        width: 80,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "First",
        accessor: "first_name",
        width: 80,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Middle",
        accessor: "middle_name",
        width: 80,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Last",
        accessor: "last_name",
        width: 80,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: 80,
        Cell: ({ value }) => (value ? value : "NA"),
      },

      {
        Header: "Bermudian",
        accessor: "bermudian",
        width: 110,

        Cell: (props) => {
          return (
            <span>
              {props.original.bermudian ? "Resident" : "non-Resident"}
            </span>
          );
        },
      },
      {
        Header: "D.O.B.",
        accessor: "dob",
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Email Address",
        accessor: "email",
        width: 230,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Phone",
        accessor: "phone",
        width: 140,
        Cell: ({ value }) => (value ? value : "NA"),
      },

      {
        Header: "Status",
        accessor: "status",
        width: 170,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Wallet Id",
        accessor: "wallet_id",
        width: 360,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Wallet Address",
        accessor: "wallet_address",
        width: 500,
        Cell: ({ value }) =>
          value ? (
            <div className="flex items-center px-3"> {/* same padding for all */}
              <span
                className="truncate max-w-[250px]"
                title={value}
              >
                {value}
              </span>
              <button
                onClick={() => {
                  if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(value).then(
                      () => console.log("Copied!"),
                      (err) => console.error("Clipboard error:", err)
                    );
                  } else {
                    // fallback for non-HTTPS
                    const textarea = document.createElement("textarea");
                    textarea.value = value;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textarea);
                    console.log("Copied (fallback)!");
                  }
                }}
                className="ml-3 flex items-center justify-center w-6 h-6 rounded border border-gray-300 bg-white hover:bg-gray-100"
                title="Copy to clipboard"
              >
                <i className="fa fa-copy text-gray-600"></i>
              </button>
            </div>
          ) : (
            <div className="px-3">NA</div> // uniform left padding
          ),
      }
      
,      
      {
        Header: "QR Code",
        accessor: "actions",
        sortable: false,
        filterable: false,
        width: 120,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          const { classes } = this.props; // make sure classes is accessible here
          const walletAddress = props.original.wallet_address;
          const profilePic = props.original.profile_pic;
          const name = props.original.first_name;
          const Id = props.original._id;
          const QrDataStr = `${Id} ${name} ${profilePic}`;
          console.log(QrDataStr, "QrDataStr");
          return (
            <div
              className="actions-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {walletAddress ? (
                <Tooltip title="View QR Code">
                  <IconButton
                    color="secondary"
                    className={classes.button}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({
                        qrValue: QrDataStr,
                        showQRModal: true,
                      });
                    }}
                    style={{ width: 40, height: 40 }} // fixed size for consistency
                  >
                    <Icon>qr_code</Icon>
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="No Wallet Address">
                  <IconButton
                    // disabled
                    style={{ width: 40, height: 40, color: "#ccc" }}
                  >
                    <Icon>qr_code</Icon>
                  </IconButton>
                </Tooltip>
              )}
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          return (
            <div className="actions-center">
              {props.original.profile_status == "unverified" ? (
                <div>
                  <Tooltip title="Approve">
                    <IconButton
                      color="primary"
                      className={classes.button}
                      onClick={(e) => {
                        e.stopPropagation();
                        let id = props.original._id;
                        this.setState({
                          showWarning: true,
                          id,
                        });
                      }}
                    >
                      <Icon>check</Icon>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Reject">
                    <IconButton
                      color="primary"
                      className={classes.button}
                      onClick={(e) => {
                        e.stopPropagation();
                        let id = props.original._id;
                        this.setState({
                          showreject: true,
                          id,
                        });
                      }}
                    >
                      <Icon>clear</Icon>
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip title="view">
                  <IconButton
                    color="primary"
                    className={classes.button}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.props.history.push("/admin/viewuser", {
                        data: props.original,
                      });
                    }}
                  >
                    <Icon>visibility</Icon>
                  </IconButton>
                </Tooltip>
              )}
            </div>
          );
        },
      },
    ];
    return column;
  };

  editCategoryFunc = (cat) => {
    if (cat) {
      let catObj = {
        _id: cat._id,
        images: cat.category_image,
        category_name: cat.category_name,
        category_description: cat.category_description,
        category_unit: cat.category_unit,
      };
      // this.props.categoryFormContent(catObj)
      this.props.history.push("/admin/addNewCategory", {
        categoryUnderView: catObj,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const {
      showWarning,
      data,
      search_event,
      userToDeleteId,
      customerData,
      showreject,
    } = this.state;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardBody>
                <TextField
                  id="standard-search"
                  label="Search User by Email Address"
                  name="search_event"
                  type="search"
                  fullWidth
                  value={search_event}
                  onChange={(event) => {
                    const { value } = event.target;
                    this.setState(
                      {
                        customerData: data,
                      },
                      () => {
                        const newwebinarData = this.state.customerData.filter(
                          (item) =>
                            item.email
                              .toLowerCase()
                              .includes(value.toLowerCase())
                        );
                        this.setState({
                          customerData: newwebinarData,
                          search_event: value.toLowerCase(),
                        });
                      }
                    );
                  }}
                  margin="normal"
                />
                <ReactTable
                  data={customerData ? customerData : []}
                  columns={this.getUserTableColumn()}
                  defaultPageSize={20}
                  pageSizeOptions={[5, 10, 20, 25, 50]}
                  showPaginationBottom={true}
                  minRows={4}
                  sortable={true}
                  // manual
                  noDataText="No Customers found"
                  onPageChange={(pageIndex) => {
                    console.log(pageIndex);
                    // let newQuery = getUserQuery;
                    // newQuery["offset"] = pageIndex * newQuery.limit;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  onPageSizeChange={(rowPerPage) => {
                    console.log(rowPerPage);
                    // let newQuery = getUserQuery;
                    // newQuery["limit"] = rowPerPage;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  // getTrProps={(state, rowInfo, column, instance) => {
                  //   return {
                  //     onClick: (e, handleOriginal) => {
                  //       if (rowInfo) {
                  //         // this.editCategoryFunc(rowInfo.original)
                  //       }
                  //     },
                  //     // style: {
                  //     //   cursor: 'pointer',
                  //     //   background: rowInfo && rowInfo.viewIndex%2 === 0 ? '#f9eddb' : '#e0d2be'
                  //     // }
                  //   };
                  // }}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <DeleteModel
          showModel={showWarning}
          title={"Are you sure you want to approve the user?"}
          onCancel={() => {
            this.setState({
              showWarning: false,
              id: null,
            });
          }}
          onOk={(e) => {
            let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
            let config = {};
            if (data) {
              config = {
                headers: { Authorization: `Bearer ${data.token}` },
              };
            }
            e.stopPropagation();

            let id = this.state.id;
            let body = {
              id: id,
              profile_status: "verified",
            };
            axios
              .put(`${domain}/user/update/appuser`, body, config)
              .then((res) => {
                if (
                  res.data.statusCode === 200 ||
                  res.data.statusCode === 201
                ) {
                  toastr.success("User Approved Successfully!");
                  this.setState({
                    showWarning: false,
                    id: null,
                  });
                  setTimeout(function() {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => {});
          }}
        />
        <DeleteModel
          showModel={showreject}
          title={"Are you sure you want to reject the user?"}
          onCancel={() => {
            this.setState({
              showreject: false,
              id: null,
            });
          }}
          onOk={() => {
            let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
            let config = {};
            if (data) {
              config = {
                headers: { Authorization: `Bearer ${data.token}` },
              };
            }
            let id = this.state.id;
            let body = {
              id: id,
              profile_status: "reject",
            };
            axios
              .put(`${domain}/user/update/appuser`, body, config)
              .then((res) => {
                if (
                  res.data.statusCode === 200 ||
                  res.data.statusCode === 201
                ) {
                  toastr.success("User Rejected Successfully!");
                  this.setState({
                    showreject: false,
                    id: null,
                  });
                  setTimeout(function() {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => {});
          }}
        />
        {this.state.showQRModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
            onClick={() => this.setState({ showQRModal: false, qrValue: null })}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: 20,
                borderRadius: 8,
                textAlign: "center",
                cursor: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <QRCodeSVG value={this.state.qrValue} size={256} />
              <div style={{ marginTop: 10 }}>
                <button
                  className="MuiButtonBase-root MuiButton-root MuiButton-text RegularButton-button-147 RegularButton-facebook-157 RegularButton-round-172"
                  onClick={() =>
                    this.setState({ showQRModal: false, qrValue: null })
                  }
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({type:PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM,payload:obj})},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManageCustomers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
